import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { RecoverPassModel } from 'src/app/models/recover-pass-user.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { faX } from '@fortawesome/free-solid-svg-icons'; // O far para regular
import { SwalService } from 'src/app/services/utls/swal.service';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-recover-pass',
  templateUrl: './recover-pass.component.html',
  styleUrls: ['./recover-pass.component.scss'],
})
export class RecoverPassComponent {
  @Input() title = '';
  @Input() msg = '';
  @Input() btn_msg_yes = '';
  @Input() btn_msg_no = '';
  @Input() callback_yes = () => { };
  @Input() callback_no = () => { };
  loginFormChangePass: RxFormGroup;
  loginCarg = false;
  faClose = faX;
  typePassword: boolean = true; // Or initialize as needed
  modalCarga?: NgbModalRef;
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  constructor(
    public activeModal: NgbActiveModal,
    private fb: RxFormBuilder,
    private authService: AuthService,
    public swalService: SwalService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.initForm();
  }
  async initForm(): Promise<void> {
    return new Promise((resolve) => {
      const Recover = new RecoverPassModel();
      this.loginFormChangePass = this.fb.formGroup(Recover) as RxFormGroup;

      resolve();
    });
  }
  recover() {
    const { lastpassword, newpassword } = this.loginFormChangePass.value;
    if (lastpassword && newpassword) {
      this.loginCarg = true; // Show loader or spinner

      this.authService.changePasswordUser(lastpassword, newpassword).subscribe({
        next: async (response) => {
          if (response) {
            this.swalService.success(
              '¡Contraseña actualizada!',
              'Tu contraseña se ha actualizado exitosamente.'
            );
          }
          this.closeModel();
          this.authService.logout();
        },
        error: (error) => {
          this.loginCarg = false; // Hide loader
          this.swalService.error(
            '¡Error!',
            error.error.message
          );
        },
      });
    } else {
      this.loginFormChangePass.markAllAsTouched();
    }
  }
  closeModel() {
    this.activeModal.close('close');
    this.callback_no();
  }
}
